import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NodeComponent } from './components/page-builder/node/node.component';
import { SampleImageComponent } from './components/blocks/sample-image/sample-image.component';
import { SampleTextComponent } from './components/blocks/sample-text/sample-text.component';
import { SocialIconsComponent } from './components/layout/social-icons/social-icons.component';
import { CompleteResultsComponent } from './components/blocks/complete-results/complete-results.component';
import { FooterComponent } from './components/layout/footer/footer.component';
import { HeaderComponent } from './components/layout/header/header.component';
import { RecursiveListComponent } from './components/layout/recursive-list/recursive-list.component';
import { RowComponent } from './components/page-builder/row/row.component';
import { CarouselComponent } from './components/blocks/carousel/carousel.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { PageCustomComponent } from './components/page-builder/content-types/page-custom/page-custom.component';
import { SampleMediaImageComponent } from './components/blocks/sample-media-image/sample-media-image.component';
import { SafePipe } from '../utility/safe.pipe';
import { CardCounterComponent } from './components/blocks/card-counter/card-counter.component';
import { SampleCardComponent } from './components/blocks/sample-card/sample-card.component';
import { SampleCarouselComponent } from './components/blocks/sample-carousel/sample-carousel.component';
import { SampleMediaVideoComponent } from './components/blocks/sample-media-video/sample-media-video.component';
import { SplitUrlImage } from '../utility/splitUrlImage.pipe';
import { SampleTestimonialComponent } from './components/blocks/sample-testimonial/sample-testimonial.component';
import { SampleDividerComponent } from './components/blocks/sample-divider/sample-divider.component';
import { SampleAlertComponent } from './components/blocks/sample-alert/sample-alert.component';
import { SampleAccordionComponent } from './components/blocks/sample-accordion/sample-accordion.component';
import { MultipleItemsComponent } from './components/page-builder/multiple-items/multiple-items.component';
import { SingleItemComponent } from './components/page-builder/single-item/single-item.component';
import { SampleEnclosureComponent } from './components/blocks/sample-enclosure/sample-enclosure.component';
import { SampleDateToRememberComponent } from './components/blocks/sample-date-to-remember/sample-date-to-remember.component';
import { SampleModalComponent } from './components/blocks/sample-modal/sample-modal.component';
import { SampleHeroComponent } from './components/blocks/sample-hero/sample-hero.component';
import { SampleJumbotronComponent } from './components/blocks/sample-jumbotron/sample-jumbotron.component';
import { SampleTextWithImageComponent } from './components/blocks/sample-text-with-image/sample-text-with-image.component';
import { SampleTabComponent } from './components/blocks/sample-tab/sample-tab.component';
import { SampleTimelineComponent } from './components/blocks/sample-timeline/sample-timeline.component';
import { BreadcrumbComponent } from './components/blocks/breadcrumb/breadcrumb.component';
import { LevelMenuComponent } from './components/blocks/level-menu/level-menu.component';
import { SampleChecklistComponent } from './components/blocks/sample-checklist/sample-checklist.component';
import { SampleButtonComponent } from './components/blocks/sample-button/sample-button.component';
import { SampleStickyBannerComponent } from './components/blocks/sample-sticky-banner/sample-sticky-bunner.component';
import { SampleIframeComponent } from './components/blocks/sample-iframe/sample-iframe.component';
import { TextHeaderComponent } from './components/blocks/text-header/text-header.component';
import { SampleAnchorComponent } from './components/blocks/sample-anchor/sample-anchor.component';
import { SpinnerComponent } from './components/blocks/spinner/spinner.component';
import { SampleParagraphComponent } from './components/blocks/sample-paragraph/sample-paragraph.component';
import { SampleTableComponent } from './components/blocks/sample-table/sample-table.component';
import { ViewSelectCourseComponent } from './components/views/view-select-course/view-select-course.component';
import { SampleSelectComponent } from './components/views/blocks/sample-select/sample-select.component';
import { SampleEventsComponent } from './components/views/sample-events/sample-events.component';
import { UpcomingRelatedEventsComponent } from './components/views/upcoming-related-events/upcoming-related-events.component';
import { HeaderEventComponent } from './components/views/blocks/header-event/header-event.component';
import { SampleCardRelatedComponent } from './components/views/blocks/sample-card-related/sample-card-related.component';
import { LoginComponent } from './components/blocks/login/login.component';
import { SampleEventsSmallComponent } from './components/views/blocks/sample-events-small/sample-events-small.component';
import { ContainerSampleCardComponent } from './components/blocks/container-sample-card/container-sample-card.component';
import { SampleSingleAnnouncementComponent } from './components/blocks/sample-single-announcement/sample-single-announcement.component';
import { SampleSinglePersonComponent } from './components/blocks/sample-single-person/sample-single-person.component';
import { SampleFeatureComponent } from './components/blocks/sample-feature/sample-feature.component';
import { SampleGeneralTitlesComponent } from './components/blocks/sample-general-titles/sample-general-titles.component';
import { SampleTrainingOfferComponent } from './components/blocks/sample-training-offer/sample-training-offer.component';
import { SampleLatestNewsComponent } from './components/views/sample-latest-news/sample-latest-news.component';
import { SampleViewCardComponent } from './components/views/blocks/sample-view-card/sample-view-card.component';
import { HighlightedParagraphComponent } from './components/blocks/highlighted-paragraph/highlighted-paragraph.component';
import { SampleWebformComponent } from './components/blocks/sample-webform/sample-webform.component';
import { SampleNewsComponent } from './components/views/sample-news/sample-news.component';
import { SampleNewsBigComponent } from './components/views/blocks/sample-news-big/sample-news-big.component';
import { SampleNewsSmallComponent } from './components/views/blocks/sample-news-small/sample-news-small.component';
import { PageNotiziaComponent } from './components/page-builder/content-types/page-notizia/page-notizia.component';
import { PageBandoComponent } from './components/page-builder/content-types/page-bando/page-bando.component';
import { PageAvvisoComponent } from './components/page-builder/content-types/page-avviso/page-avviso.component';
import { PageProceduraComponent } from './components/page-builder/content-types/page-procedura/page-procedura.component';
import { PageFaqComponent } from './components/page-builder/content-types/page-faq/page-faq.component';
import { PageConvenzioneComponent } from './components/page-builder/content-types/page-convenzione/page-convenzione.component';
import { PageAlloggioComponent } from './components/page-builder/content-types/page-alloggio/page-alloggio.component';
import { PagePersonaComponent } from './components/page-builder/content-types/page-persona/page-persona.component';
import { PageEventoComponent } from './components/page-builder/content-types/page-evento/page-evento.component';
import { BackComponent } from './components/blocks/back/back.component';
import { BreadcrumbFirstComponent } from './components/blocks/breadcrumb-first/breadcrumb-first.component';
import { SampleCardAvvisiComponent } from './components/views/blocks/sample-card-avvisi/sample-card-avvisi.component';
import { PageGeneralComponent } from './components/page-builder/content-types/page-general/page-general.component';
import { SampleViewContentComponent } from './components/views/sample-view-content/sample-view-content.component';
import { NumberShortPipe } from '../utility/number-short.pipe';
import { ViewSelectFiltersComponent } from './components/views/view-select-filters/view-select-filters.component';
import { ViewAllItemsComponent } from './components/views/view-all-items/view-all-items.component';
import { MultipleSelectComponent } from './components/views/input-filter/multiple-select/multiple-select.component';
import { TextListComponent } from './components/views/input-filter/text-list/text-list.component';
import { InputTextFilterComponent } from './components/views/input-filter/input-text-filter/input-text-filter.component';
import { InputDateFilterComponent } from './components/views/input-filter/input-date-filter/input-date-filter.component';
import { SampleCardConventionComponent } from './components/views/blocks/sample-card-convention/sample-card-convention.component';
import { SampleCardAlloggiComponent } from './components/views/blocks/sample-card-alloggi/sample-card-alloggi.component';
import { PageDocentiComponent } from './components/page-builder/content-types/page-docenti/page-docenti.component';
import { SampleCardFaqComponent } from './components/views/blocks/sample-card-faq/sample-card-faq.component';
import { SampleCardDocentiComponent } from './components/views/blocks/sample-card-docenti/sample-card-docenti.component';
import { SampleCardGeneralComponent } from './components/views/blocks/sample-card-general/sample-card-general.component';
import { PageCorsoDiStudiComponent } from './components/page-builder/content-types/page-corso-di-studi/page-corso-di-studi.component';
import { SampleCardCorsiComponent } from './components/views/blocks/sample-card-corsi/sample-card-corsi.component';
import { SampleCardPagineComponent } from './components/views/blocks/sample-card-pagine/sample-card-pagine.component';
import { SearchLibraryComponent } from './components/blocks/search-library/search-library.component';
import { ModalShareComponent } from './components/blocks/modal-share/modal-share.component';
import { SafeHtml } from '../utility/safeHtml.pipe';
import { LevelMenuExpandedComponent } from './components/blocks/level-menu-expanded/level-menu-expanded.component';
import { ContainerFieldTaxonomiesComponent } from './components/blocks/container-field-taxonomies/container-field-taxonomies.component';
import { SampleLogosComponent } from './components/blocks/sample-logos/sample-logos.component';
import { SamplePrivateFileComponent } from './components/blocks/sample-private-file/sample-private-file.component';
import { SampleNewsletterComponent } from './components/blocks/sample-newsletter/sample-newsletter.component';
import { InputMailFilterComponent } from './components/views/input-filter/input-mail-filter/input-mail-filter.component';
import { SampleCardPersoneComponent } from './components/views/blocks/sample-card-persone/sample-card-persone.component';
import { SampleViewContentRelatedComponent } from './components/views/sample-view-content-related/sample-view-content-related.component';
import { LocalizedDate } from '../utility/localized-date.pipe';
import { SamplePrintComponent } from './components/blocks/sample-print/sample-print.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { CalendarComponent } from './components/blocks/calendar/calendar.component';
import { ErrorsModule } from '../modules/errors/errors.module';
import { CarouselHeroBarComponent } from './components/blocks/carousel-hero-bar/carousel-hero-bar.component';
import { LumiaChatComponent } from './components/lumia-chat/lumia-chat.component';


@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    NodeComponent,
    RowComponent,
    SampleImageComponent,
    SampleTextComponent,
    RecursiveListComponent,
    SocialIconsComponent,
    CompleteResultsComponent,
    CarouselComponent,
    PageNotiziaComponent,
    PageCustomComponent,
    SampleMediaImageComponent,
    SafePipe,
    SafeHtml,
    CardCounterComponent,
    SampleCardComponent,
    SampleCarouselComponent,
    SampleMediaVideoComponent,
    SplitUrlImage,
    SampleTestimonialComponent,
    SampleDividerComponent,
    SampleAlertComponent,
    SampleAccordionComponent,
    MultipleItemsComponent,
    SingleItemComponent,
    SampleEnclosureComponent,
    SampleDateToRememberComponent,
    SampleModalComponent,
    SampleHeroComponent,
    SampleJumbotronComponent,
    SampleTextWithImageComponent,
    SampleTabComponent,
    SampleTimelineComponent,
    BreadcrumbComponent,
    LevelMenuComponent,
    SampleChecklistComponent,
    SampleButtonComponent,
    SampleStickyBannerComponent,
    SampleIframeComponent,
    TextHeaderComponent,
    SampleAnchorComponent,
    SpinnerComponent,
    SampleParagraphComponent,
    SampleTableComponent,
    SampleLatestNewsComponent,
    SampleViewCardComponent,
    ViewSelectCourseComponent,
    SampleSelectComponent,
    SampleEventsComponent,
    UpcomingRelatedEventsComponent,
    HeaderEventComponent,
    SampleCardRelatedComponent,
    LoginComponent,
    SampleEventsSmallComponent,
    ContainerSampleCardComponent,
    SampleSingleAnnouncementComponent,
    SampleSinglePersonComponent,
    SampleFeatureComponent,
    SampleGeneralTitlesComponent,
    PageGeneralComponent,
    SampleTrainingOfferComponent,
    HighlightedParagraphComponent,
    SampleWebformComponent,
    SampleNewsComponent,
    SampleNewsBigComponent,
    SampleNewsSmallComponent,
    PageBandoComponent,
    PageAvvisoComponent,
    PageProceduraComponent,
    PageFaqComponent,
    PageConvenzioneComponent,
    PageAlloggioComponent,
    PagePersonaComponent,
    PageEventoComponent,
    SampleViewContentComponent,
    BackComponent,
    BreadcrumbFirstComponent,
    SampleCardAvvisiComponent,
    ViewAllItemsComponent,
    ViewSelectFiltersComponent,
    MultipleSelectComponent,
    TextListComponent,
    InputTextFilterComponent,
    InputDateFilterComponent,
    InputMailFilterComponent,
    SampleCardConventionComponent,
    SampleCardAlloggiComponent,
    PageDocentiComponent,
    SampleCardFaqComponent,
    PageCorsoDiStudiComponent,
    SampleCardDocentiComponent,
    SampleCardGeneralComponent,
    NumberShortPipe,
    SampleCardCorsiComponent,
    SampleCardPagineComponent,
    SearchLibraryComponent,
    ModalShareComponent,
    LevelMenuExpandedComponent,
    ContainerFieldTaxonomiesComponent,
    SampleLogosComponent,
    SamplePrivateFileComponent,
    SampleNewsletterComponent,
    SampleCardPersoneComponent,
    SampleViewContentRelatedComponent,
    LocalizedDate,
    SamplePrintComponent,
    CalendarComponent,
    CarouselHeroBarComponent,
    LumiaChatComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CarouselModule,
    ErrorsModule,
    BrowserAnimationsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
  ],
  providers: [
    DatePipe
  ],
  exports: [
    FooterComponent,
    HeaderComponent,
    LoginComponent
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class SharedModule { }
